"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeHtml = void 0;
var _mui = require("@ori-ui/mui");
var _htmlReactParser = _interopRequireWildcard(require("html-react-parser"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const decodeHtml = ({
  html,
  elementsProps
}) => {
  const options = {
    replace: domNode => {
      if (domNode.type === 'text') {
        return domNode.data;
      }
      if (domNode.type !== 'tag') {
        return domNode;
      }
      // type assertion is needed because the type of children is not correctly inferred in html-react-parser
      const children = domNode.children;
      switch (domNode.name) {
        case 'a':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
            ...(0, _htmlReactParser.attributesToProps)(domNode.attribs),
            ...elementsProps?.linkProps,
            children: (0, _htmlReactParser.domToReact)(children, options)
          });
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
        case 'h5':
        case 'h6':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            component: domNode.name,
            variant: domNode.name,
            ...elementsProps?.headingProps,
            children: (0, _htmlReactParser.domToReact)(children, options)
          });
        case 'p':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            component: "p",
            ...elementsProps?.paragraphProps,
            children: (0, _htmlReactParser.domToReact)(children, options)
          });
        case 'b':
        case 'strong':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            component: domNode.name,
            fontWeight: "bold",
            ...elementsProps?.boldProps,
            children: (0, _htmlReactParser.domToReact)(children, options)
          });
        case 'u':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            component: domNode.name,
            style: {
              textDecoration: 'underline'
            },
            ...elementsProps?.underlineProps,
            children: (0, _htmlReactParser.domToReact)(children, options)
          });
        case 'i':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            component: domNode.name,
            style: {
              fontStyle: 'italic'
            },
            ...elementsProps?.italicProps,
            children: (0, _htmlReactParser.domToReact)(children, options)
          });
        case 'ul':
        case 'ol':
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            component: domNode.name,
            ...elementsProps?.listProps,
            children: (0, _htmlReactParser.domToReact)(children, options)
          });
        default:
          return domNode;
      }
    }
  };
  return (0, _htmlReactParser.default)(html, options);
};
exports.decodeHtml = decodeHtml;
